import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b7455ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "segmented-control" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "calendar-conatiner"
}
const _hoisted_4 = { class: "book-history-detail" }
const _hoisted_5 = { class: "board-history-detail" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createVNode($setup["NavigationBar"], { title: "탑승현황" }),
      _createElementVNode("div", {
        class: "book-history-container",
        onTouchstart: $setup.onTouchStart,
        onTouchend: $setup.onTouchEnd
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode($setup["SegmentedControl"], {
            ref: "segmentedControl",
            segments: $setup.segmentTitles,
            initialIndex: $setup.currentSegmentIndex,
            onOnChangedSegmentIndex: $setup.onChangedSegmentIndex
          }, null, 8 /* PROPS */, ["initialIndex"])
        ]),
        _createElementVNode("section", _hoisted_2, [
          ($setup.currentSegmentIndex === 0)
            ? (_openBlock(), _createBlock($setup["SelectableImageGroup"], {
                key: 0,
                class: "image-group",
                imageList: $setup.displayTypeImageList,
                selectedImageList: $setup.displayTypeSelectedImageList,
                selectedImageIndexes: $setup.selectedDisplayTypeIndexes,
                imageAltTextList: $setup.imageAltTextList,
                onOnClickImage: $setup.selectDisplayType
              }, null, 8 /* PROPS */, ["imageList", "selectedImageList", "selectedImageIndexes", "imageAltTextList"]))
            : _createCommentVNode("v-if", true),
          ($setup.currentSegmentIndex === 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                ($setup.currentDisplayType === $setup.DISPLAY_TYPE_CALENDAR)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      (_openBlock(), _createBlock($setup["EventCalendar"], {
                        class: "event-calendar",
                        key: $setup.currentSegmentIndex,
                        eventList: $setup.currentCalendarEvents,
                        displayMode: $setup.calendarDisplayMode,
                        eventColorClassMap: $setup.eventColorClassMap,
                        onOnChangeMonth: $setup.changedMonth,
                        onOnSelectDate: $setup.showBookHistoryListModal
                      }, null, 8 /* PROPS */, ["eventList", "displayMode", "eventColorClassMap"])),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.currentMonthlyBookInfos, (bookInfo) => {
                        return (_openBlock(), _createBlock($setup["BookHistoryRow"], {
                          class: "book-history-row",
                          key: bookInfo.id,
                          bookInfo: bookInfo,
                          onClick: ($event: any) => ($setup.showBookHistoryDetail(bookInfo))
                        }, null, 8 /* PROPS */, ["bookInfo", "onClick"]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : (_openBlock(), _createBlock($setup["BookHistoryTable"], {
                      class: "book-history-table-container",
                      key: $setup.updateKey,
                      bookInfos: $setup.bookInfos,
                      shouldShowFilterMenu: true,
                      filterDisplayText: $setup.currentFilterString,
                      onOnClickFilter: $setup.showFilterModal,
                      onOnSelectBookInfo: $setup.showBookHistoryDetail
                    }, null, 8 /* PROPS */, ["bookInfos", "filterDisplayText"]))
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createBlock($setup["BoardHistoryTable"], {
                key: $setup.updateKey,
                boardHistory: $setup.boardInfos,
                shouldShowEmptyContent: $setup.shouldShowEmptyContent,
                searchFromDate: $setup.searchFromDate,
                searchToDate: $setup.searchToDate,
                onOnClickFromDateInput: $setup.showFromDateCalendar,
                onOnClickToDateInput: $setup.showToDateCalendar,
                onOnSelectBoardInfo: $setup.showBoardHistoryDetail
              }, null, 8 /* PROPS */, ["boardHistory", "shouldShowEmptyContent", "searchFromDate", "searchToDate"]))
        ])
      ], 32 /* NEED_HYDRATION */),
      ($setup.shouldShowFilters)
        ? (_openBlock(), _createBlock($setup["FilterModal"], {
            key: 0,
            filters: $setup.filters,
            initialAppliedFilters: $setup.currentFilters,
            onOnClickClose: _cache[0] || (_cache[0] = ($event: any) => ($setup.shouldShowFilters = false)),
            onOnClickApply: $setup.onFilterChanged
          }, null, 8 /* PROPS */, ["filters", "initialAppliedFilters"]))
        : _createCommentVNode("v-if", true),
      _createVNode($setup["PageModal"], {
        shouldShow: $setup.shouldShowBookHistoryDetail,
        onBackHandler: () => $setup.toggleShowBookHistoryDetail(false)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode($setup["BookHistoryDetail"], {
              bookInfo: $setup.selectedBookInfo!,
              turnId: $setup.selectedBookInfo!.turnId,
              oneTimeFare: $setup.selectedBookInfo!.bookAmount,
              onOnClickClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.toggleShowBookHistoryDetail(false))),
              onOnCompleteBookCancel: $setup.onCompleteBookCancel
            }, null, 8 /* PROPS */, ["bookInfo", "turnId", "oneTimeFare"])
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow", "onBackHandler"]),
      _createVNode($setup["PageModal"], {
        shouldShow: $setup.shouldShowBoardHistoryDetail,
        onBackHandler: () => $setup.toggleShowBoardHistoryDetail(false)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode($setup["BoardHistoryDetail"], {
              boardInfo: $setup.selectedBoardInfo!,
              onOnClickClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleShowBoardHistoryDetail(false))),
              onOnCompleteSurvey: $setup.onCompleteSurvey
            }, null, 8 /* PROPS */, ["boardInfo"])
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow", "onBackHandler"]),
      ($setup.shouldShowBookHistoryListModal)
        ? (_openBlock(), _createBlock($setup["BookHistoryListModal"], {
            key: 1,
            bookInfos: $setup.selectedBookInfos,
            onOnClickBookInfo: $setup.showBookHistoryDetail,
            onOnClickClose: _cache[3] || (_cache[3] = ($event: any) => ($setup.toggleShowBookHistoryListModal(false)))
          }, null, 8 /* PROPS */, ["bookInfos"]))
        : _createCommentVNode("v-if", true),
      ($setup.shouldShowFromDateCalendar)
        ? (_openBlock(), _createBlock($setup["Calendar"], {
            key: 2,
            initialSelectedDate: $setup.searchFromDate,
            selectableFromDate: $setup.limitFromBoardDate,
            selectableToDate: $setup.limitToBoardDate,
            onOnSelectDate: $setup.onSelectFromDate,
            onOnClickClose: _cache[4] || (_cache[4] = ($event: any) => ($setup.shouldShowFromDateCalendar = false))
          }, null, 8 /* PROPS */, ["initialSelectedDate", "selectableFromDate", "selectableToDate"]))
        : _createCommentVNode("v-if", true),
      ($setup.shouldShowToDateCalendar)
        ? (_openBlock(), _createBlock($setup["Calendar"], {
            key: 3,
            initialSelectedDate: $setup.searchToDate,
            selectableFromDate: $setup.limitFromBoardDate,
            selectableToDate: $setup.limitToBoardDate,
            onOnSelectDate: $setup.onSelectToDate,
            onOnClickClose: _cache[5] || (_cache[5] = ($event: any) => ($setup.shouldShowToDateCalendar = false))
          }, null, 8 /* PROPS */, ["initialSelectedDate", "selectableFromDate", "selectableToDate"]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}